"use client";

import { ArrowUpDown } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { SearchSort } from "@/lib/search/parser";

export const SORT_LABELS: Record<SearchSort, string> = {
  source_order: "Source order",
  relevance: "Relevance",
  title_asc: "Title A–Z",
  title_desc: "Title Z–A",
  author_asc: "Author A–Z",
  author_desc: "Author Z–A",
  most_viewed: "Most viewed",
  most_favorited: "Most favorited",
};

const GROUPS: { label: string; options: SearchSort[] }[] = [
  { label: "Order", options: ["source_order", "relevance"] },
  {
    label: "Alphabetical",
    options: ["title_asc", "title_desc", "author_asc", "author_desc"],
  },
  { label: "Popularity", options: ["most_viewed", "most_favorited"] },
];

interface SortSelectProps {
  value: SearchSort;
  onChange: (value: SearchSort) => void;
  /** Hide some options (e.g. Popular view manages popularity sorts itself). */
  exclude?: SearchSort[];
  className?: string;
}

export function SortSelect({ value, onChange, exclude = [], className }: SortSelectProps) {
  return (
    <Select value={value} onValueChange={(v) => onChange(v as SearchSort)}>
      <SelectTrigger size="sm" className={className} aria-label="Sort results">
        <ArrowUpDown className="size-3.5 text-ink-3" />
        <SelectValue placeholder="Sort" />
      </SelectTrigger>
      <SelectContent align="end">
        {GROUPS.map((group, i) => {
          const options = group.options.filter((o) => !exclude.includes(o));
          if (options.length === 0) return null;
          return (
            <SelectGroup key={group.label}>
              {i > 0 && <SelectSeparator />}
              <SelectLabel>{group.label}</SelectLabel>
              {options.map((opt) => (
                <SelectItem key={opt} value={opt}>
                  {SORT_LABELS[opt]}
                </SelectItem>
              ))}
            </SelectGroup>
          );
        })}
      </SelectContent>
    </Select>
  );
}
